import { createElement } from 'react';
import { Box, Switch } from '@alifd/next';
import './index.scss';
const OadpSwitch = function OadpSwitch({ defaultChecked, size, autoWidth, disabled, ...otherProps }) {
    return (createElement(Box, { style: { width: '256px' } },
        createElement(Switch, Object.assign({ defaultChecked: defaultChecked, size: size, autoWidth: autoWidth, disabled: disabled }, otherProps))));
};
export default OadpSwitch;
